import { passCodes } from '../passCodes';
import audio from '../../../../assets/audio/kids-tracks/Text2.mp3';

export const step3bridge = {
    id: 3,
    title: 'Na rozcestí',
    taskText: `
        <p>
            Vidíš to taky? Toho zvláštního pána v tom starodávném oblečení? Nevidíš? No jo, já úplně zapomněl, 
            asi to bude ten duch, ty vy lidi nevidíte. Hmm, říká, že tu straší už nějakou dobu a prosí nás, 
            jestli bychom ho nemohli osvobodit. No já nevím, asi je nějaký důvod, proč tu zůstal strašit. 
            Tak víš co? Nabídneme mu obchod. Když mu pomůžeme, tak ať nám za to řekne, co všechno ví o tomhle místě a 
            jeho záhadné barvě. Co říkáš? Tak super i on s tím souhlasí.
        </p>
        <p>
            Osvobodit ho prý můžeme tak, že vyřešíme jeho hádanku, tak jdeme na to. 
        </p>
    `,
    cipher: {
        text: `
            <p>Podle indicií níže zjistěte, o koho se jedná.</p>
            <ul style="padding-left: 15px">
                <li>jsem vysoký a hubený</li>
                <li>mám krásné velké bílé zuby</li>
                <li>moje nejoblíbenější zvíře je netopýr</li>
                <li>nemám rád špagety s česnekem ani česnekovou pomazánku, zato si vždycky pochutnám na krvavé tlačence nebo pořádně krvavém steaku</li>
                <li>moje oblíbená barva je červená a černá</li>
            </ul>
        `,
        label: 'Úkol',
    },
    audio: audio,
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[0],
    additionalInfo: 'Odpovědí je jedno slovo',
    points: true,
    hints: [
        {
            text: 'Je to upír',
        },
    ],
};
